import { BaseParentControlDrawer } from '../../core/abstraction/BaseParentControlDrawer';
import { GAME_MODES } from '../../core/constats';

import { BackgroundMobileDrawer } from './drawers/BackgroundMobileDrawer';
import { BackgroundDesktopDrawer } from './drawers/BackgroundDesktopDrawer';
import { BackgroundLandscapeDrawer } from './drawers/BackgroundLandscapeDrawer';

class BackgroundDrawer extends BaseParentControlDrawer {
  execute(mode, config = {}) {
    return super.execute(mode, config);
  }
}

export const backgroundDrawer = new BackgroundDrawer({
  [GAME_MODES.MOBILE_LANDSCAPE]: new BackgroundLandscapeDrawer(),
  [GAME_MODES.DESKTOP]: new BackgroundDesktopDrawer(),
  [GAME_MODES.MOBILE]: new BackgroundMobileDrawer(),
});
